import awesomePhoneNumber from "awesome-phonenumber";

export const isPhoneValid = (number, regionCode = "CA") => {
  if (number) {
    const phNum = awesomePhoneNumber(number.replace("+1"), regionCode);
    return phNum.isValid();
  }
  return false;
};

export default function phoneFormat(number, regionCode = "CA") {
  if (number) {
    const phNum = awesomePhoneNumber(number.replace("+1"), regionCode);
    return phNum.getNumber("national");
  }
  return "";
}
